import { useNavigate, useParams } from "react-router-dom";
import { accountService } from "../../_services/accounts.service";
import { UserProfileCurrentQuestionnaireForm } from "./userProfile-currentQuestionnaireForm";
import { UserProfileInformationNoteList } from "./userProfile-informationNoteList";
import { UserProfileQuestionnaireList } from "./userProfile-questionnaireList";


export function UserProfileGenericQuestionnaireIndex() {
    const navigate = useNavigate();

    const { questionnaireName } = useParams<{ questionnaireName: string }>();

    return (
        <>
            <UserProfileCurrentQuestionnaireForm questionnaireName={questionnaireName || ""} />
            <UserProfileQuestionnaireList questionnaireName={questionnaireName || ""} />

            {accountService.isAdmin &&
                <div style={{ marginTop: "30px" }}>
                    <UserProfileInformationNoteList />
                </div>
            }
        </>
    );
}